import http from '@/utils/http'
export default {
  getCpUserInfo: (params, options = {}) => {
    return http({ url: '/json/web/queryCpUserInfo', data: params, options })
  },
  getProductList: (params, options = {}) => {
    return http({ url: '/json/web/productList', data: params, options })
  },
  getPayMethodList: (params, options = {}) => {
    return http({ url: '/json/web/payWayList', data: params, options })
  },
  createWebOrder: (params, options = {}) => {
    return http({ url: '/json/web/createWebOrder', data: params, options })
  },
  queryWebOrderById: (params, options = {}) => {
    return http({ url: '/json/web/queryWebOrderById', data: params, options })
  },
  getPostList: (params, options = {}) => {
    return http({ url: '/json/web/articleList', data: params, options })
  },
  getRechargeEntryList: (params, options = {}) => {
    return http({ url: '/json/web/rechargeEntryList', data: params, options })
  },
}


